import { Button, CircularProgress, Grid, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useState } from "react";
import { ErrorModal } from "../../../../components/modals/error-modal";
import MesfModal from "../../../../components/modals/modal.mesf";
import { Job } from "../models/Job";
import { SetJobEnable } from "../repositories/JobsRepository";

type Props = {
	jobSelected: Job | null;
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
};

export const OnEnableJob = ({ jobSelected, show, onHide }: Props) => {
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [openSnackbar, setOpenSnackbar] = useState(false);

	const onSubmit = async () => {
		setIsLoading(true);
		const resp = await SetJobEnable(
			!jobSelected?.Enabled!,
			jobSelected?.JobId!,
		);
		if (resp.ok) {
			setOpenSnackbar(true);
			onHide(true);
		} else {
			setError(resp.message);
			onHide(false);
		}
		setIsLoading(false);
	};

	return (
		<>
			<MesfModal
				title={`${jobSelected?.Enabled ? "DISABLE" : "ENABLE"} JOB`}
				open={show}
				handleClose={() => onHide(false)}
				id="enable-job-modal"
			>
				<MesfModal.Content>
					Are you sure you want to {jobSelected?.Enabled ? "disable" : "enable"}{" "}
					the job?
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "16px 24px" }}>
					<Grid container spacing={2} justifyContent="flex-end">
						<Grid item md={3} xs={12} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="default"
								onClick={() => onHide(false)}
							>
								Disagree
							</Button>
						</Grid>
						<Grid item md={3} xs={12} style={{ margin: 0 }}>
							<Button
								fullWidth
								startIcon={isLoading && <CircularProgress size="1rem" />}
								onClick={() => onSubmit()}
								disabled={isLoading}
								variant="contained"
								color="primary"
							>
								Agree
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
			<Snackbar
				open={openSnackbar}
				autoHideDuration={2500}
				onClose={() => setOpenSnackbar(false)}
			>
				<Alert severity="success" onClose={() => setOpenSnackbar(false)}>
					The job was {jobSelected?.Enabled ? "disabled" : "enabled"}{" "}
					succesfully
				</Alert>
			</Snackbar>
		</>
	);
};
